import React from 'react';
import { Grid } from '@mui/material';
import { Perk } from 'components/loyalty/models/PerkModel';
import { perkApi } from 'components/loyalty/PerkApi';
import { CustomersAudienceCard } from './cards/CustomersAudienceCard';
import { CustomersAwardsCard } from './cards/CustomersAwardsCard';
import { CustomersFinancialCard } from './cards/CustomersFinancialCard';
import { CustomersGeneralCard } from './cards/CustomersGeneralCard';
import { CustomersTimelineCard } from './cards/CustomersTimelineCard';
import { Award } from './models/Award';
import { Customer } from './models/Customer';
import { IUserDeletionSetting } from '@pepperhq/location-sdk';
import { CustomerSavedAddressesCard } from './cards/CustomerSavedAddressesCard';

interface CustomerViewProps {
    customer: Customer;
    awards: Award[];
    currency: string;
    paymentMode: string;
    currencySymbol: string;
    uniqueDeviceVerification: boolean;
    userDeletionSetting: Partial<IUserDeletionSetting>;
    loadCustomer: () => void;
    onCustomerChange: (data: Partial<Customer>) => void;
}

export const CustomerView: React.FC<CustomerViewProps> = props => {
    const {
        customer,
        awards,
        currency,
        paymentMode,
        currencySymbol,
        userDeletionSetting,
        uniqueDeviceVerification,
        loadCustomer,
        onCustomerChange
    } = props;
    const [loading, setLoading] = React.useState(false);
    const [perks, setPerks] = React.useState(null as Perk[]);
    React.useEffect(() => {
        const getPerks = async () => {
            setLoading(true);
            const perksResult = await perkApi.getList();
            if (!perksResult.ok) {
                setPerks(null);
            } else {
                setPerks(perksResult.body.perks);
            }
            setLoading(false);
        };
        getPerks();
    }, []);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
                <CustomersGeneralCard
                    customer={customer}
                    onChange={onCustomerChange}
                    uniqueDeviceVerification={uniqueDeviceVerification}
                    userDeletionSetting={userDeletionSetting}
                />
            </Grid>
            <Grid item xs={12} md={5}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <CustomersFinancialCard
                            customer={customer}
                            currency={currency}
                            paymentMode={paymentMode}
                            currencySymbol={currencySymbol}
                            onChange={onCustomerChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomerSavedAddressesCard customer={customer} />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomersAwardsCard
                            isLoading={loading}
                            perks={perks}
                            awards={awards}
                            customer={customer}
                            loadCustomer={loadCustomer}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomersAudienceCard customer={customer} onChange={onCustomerChange} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
                <CustomersTimelineCard
                    perks={perks}
                    title="History"
                    customerId={customer._id}
                    paymentMode={paymentMode}
                />
            </Grid>
        </Grid>
    );
};
